import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Dialog as DialogRoot, Close as DialogRootClose, Content as DialogRootContent, Description as DialogRootDescription, Overlay as DialogRootOverlay, Portal as DialogRootPortal, Title as DialogRootTitle, Trigger as DialogRootTrigger, } from "@radix-ui/react-dialog";
import Divider from "../Divider";
import { XIcon } from "lucide-react";
import cn from "../../utils/cn";
import Button from "../Button";
import Typography from "../Typography";
const Dialog = (props) => _jsx(DialogRoot, { ...props });
const DialogClose = (props) => {
    if (props.asChild)
        return _jsx(DialogRootClose, { ...props, children: props.children });
    return (_jsx(DialogRootClose, { ...props, asChild: true, children: _jsx(Button, { "aria-label": "Close", icon: _jsx(XIcon, { className: "h-6 w-6" }), variant: "link", color: "secondary", size: "auto" }) }));
};
const DialogTrigger = (props) => _jsx(DialogRootTrigger, { ...props });
const DialogPortal = (props) => _jsx(DialogRootPortal, { ...props });
const DialogOverlay = ({ className, ...props }) => (_jsx(DialogRootOverlay, { className: cn("data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 top-0 right-0 bottom-0 left-0 z-modal grid place-items-center overflow-y-auto bg-gray-a10 p-6 backdrop-blur-sm duration-300 data-[state=closed]:animate-out data-[state=open]:animate-in", className), ...props }));
const DialogContent = ({ className, children, portal = true, modalSize = "md", ...props }) => {
    const sizes = {
        sm: "modal-sm",
        md: "modal-md",
        lg: "modal-lg",
    };
    const size = sizes[modalSize];
    const Wrapper = portal ? DialogPortal : Fragment;
    return (_jsx(Wrapper, { children: _jsx(DialogOverlay, { children: _jsx(DialogRootContent, { className: cn(`z-modal bg-white ${size} gap-4 py-5 shadow-modal sm:rounded-lg`, className), ...props, children: children }) }) }));
};
const DialogHeader = ({ className, children, ...props }) => (_jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("div", { className: cn("flex items-center justify-between px-5", className), ...props, children: children }), _jsx(Divider, {})] }));
const DialogBody = ({ className, ...props }) => _jsx("div", { className: cn("flex flex-col px-5 py-2.5", className), ...props });
const DialogFooter = ({ className, children, ...props }) => (_jsxs("div", { className: "flex flex-col", children: [_jsx(Divider, {}), _jsx("div", { ...props, className: cn("flex px-5 pt-5", className), children: children })] }));
const DialogTitle = ({ className, children, ...props }) => (_jsx(DialogRootTitle, { className: className, ...props, children: _jsxs(Typography, { variant: "heading-2", children: [" ", children, " "] }) }));
const DialogDescription = ({ className, ...props }) => _jsx(DialogRootDescription, { className: cn("text-muted-foreground text-sm", className), ...props });
Dialog.Portal = DialogPortal;
Dialog.Overlay = DialogOverlay;
Dialog.Close = DialogClose;
Dialog.Trigger = DialogTrigger;
Dialog.Content = DialogContent;
Dialog.Header = DialogHeader;
Dialog.Footer = DialogFooter;
Dialog.Body = DialogBody;
Dialog.Title = DialogTitle;
Dialog.Description = DialogDescription;
export default Dialog;
